import React from 'react'
import { css } from 'emotion'
import { Text, View } from 'oio-react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import MoreIcon from 'assets/icons/more'

const ContentListItemRow = ({
   dateLastUpdated,
   editUrl,
   icon,
   name,
   onOptionsButtonClick
}) => (
   <View
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      width="100%"
      padding="12px 9px"
      borderBottom="1px solid rgba(0,0,0,0.05)"
      className={css`
         &:hover {
            background-color: #f5f5f5;
         }
      `}>
      <View display="flex" alignItems="center">
         <View
            width="30px"
            height="30px"
            borderRadius="3px"
            backgroundColor={!icon && '#eee'}
            marginRight="12px">
            {icon}
         </View>
         <View>
            <Link to={editUrl}>
               <Text size="2" weight="medium" color="#111">
                  {name}
               </Text>
            </Link>
            <Text size="1" color="#888">
               {`Last Updated ${dateLastUpdated}`}
            </Text>
         </View>
      </View>
      <View
         position="relative"
         onClick={onOptionsButtonClick}>
         <MoreIcon
            width="24px"
            height="24px"
            color="#aaa"
         />
      </View>
   </View>
)

ContentListItemRow.propTypes = {
   dateLastUpdated: PropTypes.string.isRequired,
   editUrl: PropTypes.string.isRequired,
   icon: PropTypes.node,
   name: PropTypes.string.isRequired,
   onOptionsButtonClick: PropTypes.func.isRequired
}

ContentListItemRow.defaultProps = {
   icon: undefined
}

export default ContentListItemRow
